import { Injectable, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from '@lohi/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, pluck, shareReplay, switchMapTo, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

export type SSETopic = 'lohiPay' | 'tourRecommendations';

interface RawData {
  topic: SSETopic;
  data: any;
}

const messageCache: Partial<Record<SSETopic, Observable<any>>> = {};

@Injectable({
  providedIn: 'root',
})
export class ServerSentEventsService {
  private data$$ = new BehaviorSubject<RawData | null>(null);
  public eventSource: EventSource;
  constructor(private authService: AuthService, private afAuth: AngularFireAuth, private zone: NgZone) {
    this.connect();
  }

  public messagesFor$(topic: SSETopic): Observable<any> {
    if (!messageCache[topic]) {
      messageCache[topic] = this.data$$.pipe(
        filter((d) => !!d && d.topic === topic),
        pluck('data'),
        shareReplay(1),
      );
    }
    return messageCache[topic];
  }

  private async connect() {
    const token = await this.authService.isLoggedIn$
      .pipe(
        filter((isLoggedIn) => !!isLoggedIn),
        switchMapTo(this.afAuth.idToken),
        take(1),
      )
      .toPromise();
    this.eventSource = new EventSource(`${environment.api}/server_sent_events?token=${token}`);
    this.eventSource.onmessage = (ev) => {
      const payload = JSON.parse(ev.data);
      this.zone.run(() => this.data$$.next(payload));
    };
  }
}
